import { render, staticRenderFns } from "./BecomeMember.vue?vue&type=template&id=352aa5cc&scoped=true&"
import script from "./BecomeMember.vue?vue&type=script&lang=js&"
export * from "./BecomeMember.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "352aa5cc",
  null
  
)

export default component.exports